"use client"

import React from "react"

const SelectContext = React.createContext()

const Select = ({ value, onValueChange, children, ...props }) => {
  const [isOpen, setIsOpen] = React.useState(false)

  return (
    <SelectContext.Provider value={{ value, onValueChange, isOpen, setIsOpen }}>
      <div className="select-container" {...props}>
        {children}
      </div>
    </SelectContext.Provider>
  )
}

const SelectTrigger = React.forwardRef(({ className = "", children, ...props }, ref) => {
  const { isOpen, setIsOpen } = React.useContext(SelectContext)

  return (
    <button ref={ref} className={`select-trigger ${className}`} onClick={() => setIsOpen(!isOpen)} {...props}>
      {children}
      <svg
        className={`select-chevron ${isOpen ? "select-chevron-open" : ""}`}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
      </svg>
    </button>
  )
})
SelectTrigger.displayName = "SelectTrigger"

const SelectValue = ({ placeholder, ...props }) => {
  const { value } = React.useContext(SelectContext)

  return <span {...props}>{value || placeholder}</span>
}

const SelectContent = React.forwardRef(({ className = "", children, ...props }, ref) => {
  const { isOpen } = React.useContext(SelectContext)

  if (!isOpen) return null

  return (
    <div ref={ref} className={`select-content ${className}`} {...props}>
      {children}
    </div>
  )
})
SelectContent.displayName = "SelectContent"

const SelectItem = React.forwardRef(({ className = "", children, value, ...props }, ref) => {
  const { onValueChange, setIsOpen } = React.useContext(SelectContext)

  return (
    <div
      ref={ref}
      className={`select-item ${className}`}
      onClick={() => {
        if (onValueChange) {
          onValueChange(value)
        }
        setIsOpen(false)
      }}
      {...props}
    >
      {children}
    </div>
  )
})
SelectItem.displayName = "SelectItem"

export { Select, SelectTrigger, SelectValue, SelectContent, SelectItem }
